"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  author: "\n",
  quote: "Varastomikkelin kautta löysin täydellisen tilan harrastusvälineilleni. Prosessi oli uskomattoman sujuva.",
  position: "Yksityisasiakas"
}, {
  author: "\n",
  quote: "\"Edullisuus\xA0ja helppo sijainti ovat meille tärkeitä. Tämä palvelu täytti kaikki odotuksemme.\"",
  position: "Yritysasiakas"
}];
export default function WordFromTheField() {
  return;
}